import { segmentsIcon } from "../../Resources/drawing-icons";
import { segments } from "./drawing-segments-icons";
import { DrawingModuleContainer } from "../../ModuleBase/DrawingModuleContainer";
import { DrawSegmentsModule } from "./segments-module";

export class DrawSegmentsModuleContainer extends DrawingModuleContainer {
	constructor(canvas) {
		super(canvas);

		this.moduleId = "segments";
		this.toolbarWidth = "200px";
		this.icon = segmentsIcon;
		this.label = "segments";

		let props = Object.getOwnPropertyNames(segments);
		this.submodules = props.map(p => new DrawSegmentsModule(canvas, segments[p]));
	}
}

window.customElements.define(
	"inspx-draw-segments-container",
	DrawSegmentsModuleContainer
);
